/*
 * @author Andrey Patyuchenko
 * @email  apatyuchenko@atlassian.com
 * @email  andrey.patyuchenko@gmail.com
 * @date   3/14/22
 */

import React from "react";
import {Stack, Typography, useTheme} from "@mui/material";
import {Employee} from "../interfaces/Global";
import ViewportEvent from "./ViewportEvent";
import {formatDistance} from "date-fns";
import {format} from "../dates-helper";
export interface OooViewportEventProps {
	viewportRange: Interval
	rangeResolution: number
	employee: Employee
	event: Interval
}

export default function OooViewportEvent(props: OooViewportEventProps) {

	const theme = useTheme();

	return (
		<ViewportEvent
			viewportRange={props.viewportRange}
			rangeResolution={props.rangeResolution}
			normalizeTimezone={props.employee.timeZone}
			details={false}
			event={{
				title: "Out Of Office",
				typeId: "OOO",
				startDatetime: new Date(props.event.start),
				endDatetime: new Date(props.event.end)
			}}
			tooltip={
				<EventTooltip
					event={props.event}
					employee={props.employee}
				/>
			}
			getViewportLabel={() => {
				return "Out Of Office";
			}}
			sx={{
				backgroundColor: theme.palette.background.paper ,
				zIndex: 20,
				backgroundImage: "repeating-linear-gradient(-45deg, transparent 0 5px, " +
					theme.palette.grey[theme.palette.mode === "light" ? "200" : "700"]+" 5px 10px)"
			}}
		/>
	);

}

interface EventTooltipProps {
	event: Interval
	employee: Employee
}

function EventTooltip({ event, employee }: EventTooltipProps) {

	return (
		<Stack>
			<div>{employee.displayName}</div>
			<Typography>Out Of Office</Typography>
			<Stack>From: {format(event.start, 'PPPP pp')}</Stack>
			<Stack>To: {format(event.end, 'PPPP pp')}</Stack>
			<Stack>{formatDistance(event.end, event.start)}</Stack>
		</Stack>
	)

}